module.exports = __webpack_public_path__ + "img/soft-bg-1-dark.b450089d.png";